import tippy from 'tippy.js';

tippy.setDefaultProps({
  arrow: true,
  animation: 'fade',
  duration: ['100', '200'],
  theme: 'cobot',
});

let tippyInstances = [];

export default function enableTippy() {
  tippyInstances.forEach((instance) => {
    instance.destroy();
  });
  tippyInstances = [];

  Array.from(
    document.querySelectorAll('[data-tippy]:not([data-white-bg-tippy])'),
  ).forEach(function (el) {
    const content = el.dataset.tippy;
    if (content) {
      const instance = tippy(el, { content: content });
      tippyInstances.push(instance);
    }
  });
  Array.from(document.querySelectorAll('[data-white-bg-tippy]')).forEach(
    function (el) {
      const content = el.dataset.tippy;
      if (content) {
        const instance = tippy(el, {
          content: content,
          theme: 'white-background',
          allowHTML: true,
          interactive: true,
          trigger: 'click',
          onTrigger: function (_instance, event) {
            event.stopPropagation();
            event.preventDefault();
          },
        });
        tippyInstances.push(instance);
      }
    },
  );
}
